import {getServiceName} from '@features/home/utils.tsx'
import {Assignment} from '@features/assignment/types.ts'

export const ListingTableCellInfo = ({item}: {item: Assignment}) => {
    return (
        <div className="flex flex-col gap-0.5 overflow-hidden text-sm whitespace-nowrap w-full [&_p]:text-neutral-600 [&_p]:overflow-hidden [&_p]:text-ellipsis [&_p]:w-full [&_a]:font-medium [&_a]:overflow-hidden [&_a]:text-neutral-900 [&_a]:underline [&_a]:cursor-pointer [&_a]:text-ellipsis [&_a]:w-full">
            <a href={item.airbnb_link} target="_blank" rel="noopener noreferrer">
                {item.entity.title || item.entity.external_id}
            </a>
            <p>{getServiceName(item?.entity_type.name, item?.task_category.name, item?.task_media.name)}</p>
        </div>
    )
}
